module.exports = __webpack_public_path__ + "img/content2.8296f9df.png";